// extracted by mini-css-extract-plugin
export default {"checkbox_wrapper":"Checkbox_checkbox_wrapper__+9Mvq","styled_checkbox":"Checkbox_styled_checkbox__04tH-"};